<template>
  <div class="table">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.table {
  padding: 0 20px;
  .ant-table-body {
    height: calc(100vh - 343px);
  }
}
</style>
